import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M19.0625 0.980469C19.2969 0.980469 19.5312 1.09766 19.7266 1.25391C19.8828 1.44922 20 1.68359 20 1.91797C20 2.19141 19.8828 2.42578 19.7266 2.58203L12.5 9.80859V20.043C12.5 20.4336 12.3047 20.7461 11.9922 20.9023C11.6406 21.0586 11.3281 21.0586 11.0156 20.8242L7.89062 18.6367C7.61719 18.4414 7.5 18.168 7.5 17.8555V9.80859L0.273438 2.58203C0.078125 2.42578 0 2.19141 0 1.91797C0 1.68359 0.078125 1.44922 0.273438 1.25391C0.429688 1.09766 0.664062 0.980469 0.9375 0.980469H19.0625Z",
		fill: "currentColor"
	})
});
export default SvgFilterSolid;
